export default __webpack_public_path__ + "static/media/gallery_06.cee70c35.jpg";